import React from 'react';

import PropTypes from 'prop-types';
import { faStar as faStarEmpty } from '@awesome.me/kit-a6e51d954f/icons/classic/regular';
import { faStar as faStarSolid } from '@awesome.me/kit-a6e51d954f/icons/classic/solid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ATTRIBUTES = {
  empty: {
    ariaLabel: 'Empty star',
    color: 'text-gray-400',
    icon: faStarEmpty,
  },
  filled: {
    ariaLabel: 'Filled star',
    color: 'text-yellow-400',
    icon: faStarSolid,
  },
};

const MAX_RATING = 5;

const RatingCell = ({ row }) => {
  const { rating } = row.original;

  return (
    <div>
      {Array.from({ length: MAX_RATING }, (_, index) => {
        const starType = index < rating ? 'filled' : 'empty';

        return (
          <FontAwesomeIcon
            aria-label={ATTRIBUTES[starType].ariaLabel}
            className={ATTRIBUTES[starType].color}
            icon={ATTRIBUTES[starType].icon}
            key={index}
          />
        );
      })}
    </div>
  );
};

RatingCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      rating: PropTypes.number.isRequired,
    }),
  }).isRequired,
};

export default RatingCell;
